// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nr-1";
export var messageSideRight = "_nr-2";
export var orderLookupBubbleContainer = "_nr-0";
export var submitButton = "_nr-3";